import { REDUCER } from '../../reducers/reducersConst';

export let setSearchResult = (searchResult = {}) => {
  return {
    type: REDUCER.SEARCH.SEARCH_RESULTS,
    searchResult
  };
};

export let setContext = (context = {}) => {
  return {
    type: REDUCER.SEARCH.CONTEXT,
    context
  };
};

export let setSearchMode = (isActive = true) => {
  return {
    type: REDUCER.SEARCH.MODE,
    isActive
  };
};
